// Shared GLSL ocean noise functions used by ProceduralOcean and OceanFloor
// Requires uniforms: uTime, uSeaSpeed, uSeaFreq, uSeaHeight, uSeaChoppy

export const oceanNoiseGLSL = `
float hash(vec2 p) {
    float h = dot(p, vec2(127.1, 311.7));
    return fract(sin(h) * 43758.5453123);
}

float noise(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    vec2 u = f * f * (3.0 - 2.0 * f);
    return -1.0 + 2.0 * mix(
        mix(hash(i + vec2(0.0, 0.0)), hash(i + vec2(1.0, 0.0)), u.x),
        mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x),
        u.y
    );
}

float sea_octave(vec2 uv, float choppy) {
    uv += noise(uv);
    vec2 wv = 1.0 - abs(sin(uv));
    vec2 swv = abs(cos(uv));
    wv = mix(wv, swv, wv);
    return pow(1.0 - pow(wv.x * wv.y, 0.65), choppy);
}
`;

// getHeight with configurable iteration count
export function getHeightGLSL(iterCount = 3) {
  return `
float getHeight(vec2 xz) {
    float SEA_TIME = uTime * uSeaSpeed;
    float freq = uSeaFreq;
    float amp = uSeaHeight;
    float choppy = uSeaChoppy;
    vec2 uv = xz;
    uv.x *= 0.75;
    mat2 m = mat2(1.6, 1.2, -1.2, 1.6);

    float d, h = 0.0;
    for(int i = 0; i < ${iterCount}; i++) {
        d = sea_octave((uv + SEA_TIME) * freq, choppy);
        d += sea_octave((uv - SEA_TIME) * freq, choppy);
        h += d * amp;
        uv *= m;
        freq *= 1.9;
        amp *= 0.22;
        choppy = mix(choppy, 1.0, 0.2);
    }
    return h;
}
`;
}
